import findLastIndex from 'lodash/findLastIndex'

import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'
import { InvoiceFormLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormLine'
import { InvoiceFormSubtotalLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormSubtotalLine'
import { isInvoiceFormRowLine } from '@features/invoices/utils/isInvoiceFormRowLine'
import { sumRowLineTotals } from '@features/invoices/utils/sumRowLineTotals'

export const getDefaultSubtotalLine = (lines: InvoiceFormLine[]): InvoiceFormSubtotalLine => {
  const lastSubtotalIndex = findLastIndex(lines, (line) => line.type === InvoiceLineType.Subtotal)
  const rowLines = lines.slice(lastSubtotalIndex + 1).filter(isInvoiceFormRowLine)

  return {
    ...sumRowLineTotals(rowLines),
    type: InvoiceLineType.Subtotal,
  }
}
